import { render, staticRenderFns } from "./EcoFriendlyComponent.vue?vue&type=template&id=22d651a1&scoped=true&"
import script from "./EcoFriendlyComponent.vue?vue&type=script&lang=ts&"
export * from "./EcoFriendlyComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d651a1",
  null
  
)

export default component.exports